import {
  childrenPropsSDKFactory,
  clickPropsSDKFactory,
  composeSDKFactories,
  createElementPropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { IHamburgerOverlayProps } from '../HamburgerOverlay.props';

type IHamburgerOverlaySDK = ReturnType<typeof createElementPropsSDKFactory> &
  ReturnType<typeof clickPropsSDKFactory> &
  ReturnType<typeof childrenPropsSDKFactory>;

const elementPropsSDKFactory = createElementPropsSDKFactory({
  useHiddenCollapsed: false,
});

export const sdk = composeSDKFactories<
  IHamburgerOverlayProps,
  IHamburgerOverlaySDK
>([elementPropsSDKFactory, clickPropsSDKFactory, childrenPropsSDKFactory]);

export default createComponentSDKModel(sdk);
